<template>
  <div>
    <van-nav-bar
      :title="title"
      @click-left="goBack">
      <span class="left" slot="left">
        <img src="@/assets/left.png" alt="">
      </span>
      </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: 'heaDer',
  props: {
    title: {
      type: String
    }
  },
  data () {
    return {
      show: null
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }

}
</script>

<style scoped lang="less">
.van-nav-bar {
  height:1.92rem;
  background: #928FFF;
  padding-top: 0.64rem;
 ::v-deep .van-nav-bar__title {
    color: #FFFFFF;
    font-size: 0.48rem;
  }
  .left {
    display: flex;
    align-items: center;
    img {
      width: 0.64rem;
      height:0.64rem;
    }
  }
}
</style>
